/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiDefApiConfiguration } from '../api-def-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiDefApiKeyData } from '../models/api-def-api-key-data';
import { ApiDefBillingHistoryListResponse } from '../models/api-def-billing-history-list-response';
import { ApiDefInvitationData } from '../models/api-def-invitation-data';
import { ApiDefMarkdownCheckResult } from '../models/api-def-markdown-check-result';
import { ApiDefMarkdownData } from '../models/api-def-markdown-data';
import { ApiDefOrganizationData } from '../models/api-def-organization-data';
import { organizationsAddOrInviteUser } from '../fn/organizations/organizations-add-or-invite-user';
import { OrganizationsAddOrInviteUser$Params } from '../fn/organizations/organizations-add-or-invite-user';
import { organizationsCancelInvitation } from '../fn/organizations/organizations-cancel-invitation';
import { OrganizationsCancelInvitation$Params } from '../fn/organizations/organizations-cancel-invitation';
import { organizationsCancelScheduledChange } from '../fn/organizations/organizations-cancel-scheduled-change';
import { OrganizationsCancelScheduledChange$Params } from '../fn/organizations/organizations-cancel-scheduled-change';
import { organizationsCheckMarkdownAndCreateVersion } from '../fn/organizations/organizations-check-markdown-and-create-version';
import { OrganizationsCheckMarkdownAndCreateVersion$Params } from '../fn/organizations/organizations-check-markdown-and-create-version';
import { organizationsCheckSpecAndCreateVersion } from '../fn/organizations/organizations-check-spec-and-create-version';
import { OrganizationsCheckSpecAndCreateVersion$Params } from '../fn/organizations/organizations-check-spec-and-create-version';
import { organizationsCreateApiKey } from '../fn/organizations/organizations-create-api-key';
import { OrganizationsCreateApiKey$Params } from '../fn/organizations/organizations-create-api-key';
import { organizationsCreateBillingPortalSession } from '../fn/organizations/organizations-create-billing-portal-session';
import { OrganizationsCreateBillingPortalSession$Params } from '../fn/organizations/organizations-create-billing-portal-session';
import { organizationsCreateOrUpdateSubscription } from '../fn/organizations/organizations-create-or-update-subscription';
import { OrganizationsCreateOrUpdateSubscription$Params } from '../fn/organizations/organizations-create-or-update-subscription';
import { organizationsCreateProject } from '../fn/organizations/organizations-create-project';
import { OrganizationsCreateProject$Params } from '../fn/organizations/organizations-create-project';
import { organizationsCreateSupportReport } from '../fn/organizations/organizations-create-support-report';
import { OrganizationsCreateSupportReport$Params } from '../fn/organizations/organizations-create-support-report';
import { organizationsCreateWithProject } from '../fn/organizations/organizations-create-with-project';
import { OrganizationsCreateWithProject$Params } from '../fn/organizations/organizations-create-with-project';
import { organizationsDeleteApiKey } from '../fn/organizations/organizations-delete-api-key';
import { OrganizationsDeleteApiKey$Params } from '../fn/organizations/organizations-delete-api-key';
import { organizationsDeleteById } from '../fn/organizations/organizations-delete-by-id';
import { OrganizationsDeleteById$Params } from '../fn/organizations/organizations-delete-by-id';
import { organizationsDeleteMarkdownVersion } from '../fn/organizations/organizations-delete-markdown-version';
import { OrganizationsDeleteMarkdownVersion$Params } from '../fn/organizations/organizations-delete-markdown-version';
import { organizationsDeleteProjectById } from '../fn/organizations/organizations-delete-project-by-id';
import { OrganizationsDeleteProjectById$Params } from '../fn/organizations/organizations-delete-project-by-id';
import { organizationsDeleteSpecVersion } from '../fn/organizations/organizations-delete-spec-version';
import { OrganizationsDeleteSpecVersion$Params } from '../fn/organizations/organizations-delete-spec-version';
import { organizationsDeleteSupportReport } from '../fn/organizations/organizations-delete-support-report';
import { OrganizationsDeleteSupportReport$Params } from '../fn/organizations/organizations-delete-support-report';
import { organizationsGetAllByUserId } from '../fn/organizations/organizations-get-all-by-user-id';
import { OrganizationsGetAllByUserId$Params } from '../fn/organizations/organizations-get-all-by-user-id';
import { organizationsGetApiKey } from '../fn/organizations/organizations-get-api-key';
import { OrganizationsGetApiKey$Params } from '../fn/organizations/organizations-get-api-key';
import { organizationsGetBillingHistory } from '../fn/organizations/organizations-get-billing-history';
import { OrganizationsGetBillingHistory$Params } from '../fn/organizations/organizations-get-billing-history';
import { organizationsGetById } from '../fn/organizations/organizations-get-by-id';
import { OrganizationsGetById$Params } from '../fn/organizations/organizations-get-by-id';
import { organizationsGetInvitationById } from '../fn/organizations/organizations-get-invitation-by-id';
import { OrganizationsGetInvitationById$Params } from '../fn/organizations/organizations-get-invitation-by-id';
import { organizationsGetMarkdownValidationResults } from '../fn/organizations/organizations-get-markdown-validation-results';
import { OrganizationsGetMarkdownValidationResults$Params } from '../fn/organizations/organizations-get-markdown-validation-results';
import { organizationsGetPaymentRecovery } from '../fn/organizations/organizations-get-payment-recovery';
import { OrganizationsGetPaymentRecovery$Params } from '../fn/organizations/organizations-get-payment-recovery';
import { organizationsGetPendingInvitations } from '../fn/organizations/organizations-get-pending-invitations';
import { OrganizationsGetPendingInvitations$Params } from '../fn/organizations/organizations-get-pending-invitations';
import { organizationsGetProjectById } from '../fn/organizations/organizations-get-project-by-id';
import { OrganizationsGetProjectById$Params } from '../fn/organizations/organizations-get-project-by-id';
import { organizationsGetProjects } from '../fn/organizations/organizations-get-projects';
import { OrganizationsGetProjects$Params } from '../fn/organizations/organizations-get-projects';
import { organizationsGetSpecValidationResults } from '../fn/organizations/organizations-get-spec-validation-results';
import { OrganizationsGetSpecValidationResults$Params } from '../fn/organizations/organizations-get-spec-validation-results';
import { organizationsGetSupportReportById } from '../fn/organizations/organizations-get-support-report-by-id';
import { OrganizationsGetSupportReportById$Params } from '../fn/organizations/organizations-get-support-report-by-id';
import { organizationsGetSupportReports } from '../fn/organizations/organizations-get-support-reports';
import { OrganizationsGetSupportReports$Params } from '../fn/organizations/organizations-get-support-reports';
import { organizationsGetUsers } from '../fn/organizations/organizations-get-users';
import { OrganizationsGetUsers$Params } from '../fn/organizations/organizations-get-users';
import { organizationsListApiKeys } from '../fn/organizations/organizations-list-api-keys';
import { OrganizationsListApiKeys$Params } from '../fn/organizations/organizations-list-api-keys';
import { organizationsRemoveUser } from '../fn/organizations/organizations-remove-user';
import { OrganizationsRemoveUser$Params } from '../fn/organizations/organizations-remove-user';
import { organizationsReorderMarkdowns } from '../fn/organizations/organizations-reorder-markdowns';
import { OrganizationsReorderMarkdowns$Params } from '../fn/organizations/organizations-reorder-markdowns';
import { organizationsReorderSpecs } from '../fn/organizations/organizations-reorder-specs';
import { OrganizationsReorderSpecs$Params } from '../fn/organizations/organizations-reorder-specs';
import { organizationsResendInvitation } from '../fn/organizations/organizations-resend-invitation';
import { OrganizationsResendInvitation$Params } from '../fn/organizations/organizations-resend-invitation';
import { organizationsRespondInvitation } from '../fn/organizations/organizations-respond-invitation';
import { OrganizationsRespondInvitation$Params } from '../fn/organizations/organizations-respond-invitation';
import { organizationsUpdateApiKey } from '../fn/organizations/organizations-update-api-key';
import { OrganizationsUpdateApiKey$Params } from '../fn/organizations/organizations-update-api-key';
import { organizationsUpdateById } from '../fn/organizations/organizations-update-by-id';
import { OrganizationsUpdateById$Params } from '../fn/organizations/organizations-update-by-id';
import { organizationsUpdateMarkdownVersion } from '../fn/organizations/organizations-update-markdown-version';
import { OrganizationsUpdateMarkdownVersion$Params } from '../fn/organizations/organizations-update-markdown-version';
import { organizationsUpdateProjectById } from '../fn/organizations/organizations-update-project-by-id';
import { OrganizationsUpdateProjectById$Params } from '../fn/organizations/organizations-update-project-by-id';
import { organizationsUpdateSpecVersion } from '../fn/organizations/organizations-update-spec-version';
import { OrganizationsUpdateSpecVersion$Params } from '../fn/organizations/organizations-update-spec-version';
import { organizationsUpdateSupportReport } from '../fn/organizations/organizations-update-support-report';
import { OrganizationsUpdateSupportReport$Params } from '../fn/organizations/organizations-update-support-report';
import { organizationsUpdateUserRole } from '../fn/organizations/organizations-update-user-role';
import { OrganizationsUpdateUserRole$Params } from '../fn/organizations/organizations-update-user-role';
import { ApiDefPaymentRecoveryResponse } from '../models/api-def-payment-recovery-response';
import { ApiDefProjectData } from '../models/api-def-project-data';
import { ApiDefSpecCheckResult } from '../models/api-def-spec-check-result';
import { ApiDefSpecData } from '../models/api-def-spec-data';
import { ApiDefSubscriptionChangeResponse } from '../models/api-def-subscription-change-response';
import { ApiDefSupportReport } from '../models/api-def-support-report';
import { ApiDefUserData } from '../models/api-def-user-data';


/**
 * Operations related to organizations and projects
 */
@Injectable({ providedIn: 'root' })
export class OrganizationsService extends BaseService {
  constructor(config: ApiDefApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organizationsGetAllByUserId()` */
  static readonly OrganizationsGetAllByUserIdPath = '/organizations';

  /**
   * Get all organizations for the user.
   *
   * Retrieve all organizations for the user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetAllByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetAllByUserId$Response(params?: OrganizationsGetAllByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiDefOrganizationData>>> {
    return organizationsGetAllByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all organizations for the user.
   *
   * Retrieve all organizations for the user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetAllByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetAllByUserId(params?: OrganizationsGetAllByUserId$Params, context?: HttpContext): Observable<Array<ApiDefOrganizationData>> {
    return this.organizationsGetAllByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ApiDefOrganizationData>>): Array<ApiDefOrganizationData> => r.body)
    );
  }

  /** Path part for operation `organizationsCreateWithProject()` */
  static readonly OrganizationsCreateWithProjectPath = '/organizations';

  /**
   * Create a new organization with a project.
   *
   * Create a new organization with a project
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCreateWithProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateWithProject$Response(params: OrganizationsCreateWithProject$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
'project'?: ApiDefProjectData;
}>> {
    return organizationsCreateWithProject(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new organization with a project.
   *
   * Create a new organization with a project
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCreateWithProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateWithProject(params: OrganizationsCreateWithProject$Params, context?: HttpContext): Observable<{
'organization'?: ApiDefOrganizationData;
'project'?: ApiDefProjectData;
}> {
    return this.organizationsCreateWithProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
'project'?: ApiDefProjectData;
}>): {
'organization'?: ApiDefOrganizationData;
'project'?: ApiDefProjectData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsGetById()` */
  static readonly OrganizationsGetByIdPath = '/organizations/{organizationId}';

  /**
   * Get an organization by ID.
   *
   * Retrieve an organization by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetById$Response(params: OrganizationsGetById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefOrganizationData>> {
    return organizationsGetById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an organization by ID.
   *
   * Retrieve an organization by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetById(params: OrganizationsGetById$Params, context?: HttpContext): Observable<ApiDefOrganizationData> {
    return this.organizationsGetById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefOrganizationData>): ApiDefOrganizationData => r.body)
    );
  }

  /** Path part for operation `organizationsDeleteById()` */
  static readonly OrganizationsDeleteByIdPath = '/organizations/{organizationId}';

  /**
   * Delete an organization by ID.
   *
   * Delete an organization by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsDeleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteById$Response(params: OrganizationsDeleteById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return organizationsDeleteById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an organization by ID.
   *
   * Delete an organization by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsDeleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteById(params: OrganizationsDeleteById$Params, context?: HttpContext): Observable<void> {
    return this.organizationsDeleteById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateById()` */
  static readonly OrganizationsUpdateByIdPath = '/organizations/{organizationId}';

  /**
   * Update an organization by ID.
   *
   * Update an organization by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateById$Response(params: OrganizationsUpdateById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefOrganizationData>> {
    return organizationsUpdateById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an organization by ID.
   *
   * Update an organization by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateById(params: OrganizationsUpdateById$Params, context?: HttpContext): Observable<ApiDefOrganizationData> {
    return this.organizationsUpdateById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefOrganizationData>): ApiDefOrganizationData => r.body)
    );
  }

  /** Path part for operation `organizationsGetProjects()` */
  static readonly OrganizationsGetProjectsPath = '/organizations/{organizationId}/projects';

  /**
   * Get projects in an organization.
   *
   * Retrieve projects in an organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetProjects$Response(params: OrganizationsGetProjects$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiDefProjectData>>> {
    return organizationsGetProjects(this.http, this.rootUrl, params, context);
  }

  /**
   * Get projects in an organization.
   *
   * Retrieve projects in an organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetProjects(params: OrganizationsGetProjects$Params, context?: HttpContext): Observable<Array<ApiDefProjectData>> {
    return this.organizationsGetProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ApiDefProjectData>>): Array<ApiDefProjectData> => r.body)
    );
  }

  /** Path part for operation `organizationsCreateProject()` */
  static readonly OrganizationsCreateProjectPath = '/organizations/{organizationId}/projects';

  /**
   * Create a new project in an organization.
   *
   * Create a new project in an organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCreateProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateProject$Response(params: OrganizationsCreateProject$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'organization'?: ApiDefOrganizationData;
}>> {
    return organizationsCreateProject(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new project in an organization.
   *
   * Create a new project in an organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCreateProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateProject(params: OrganizationsCreateProject$Params, context?: HttpContext): Observable<{
'project'?: ApiDefProjectData;
'organization'?: ApiDefOrganizationData;
}> {
    return this.organizationsCreateProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'project'?: ApiDefProjectData;
'organization'?: ApiDefOrganizationData;
}>): {
'project'?: ApiDefProjectData;
'organization'?: ApiDefOrganizationData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsGetProjectById()` */
  static readonly OrganizationsGetProjectByIdPath = '/organizations/{organizationId}/projects/{projectId}';

  /**
   * Get a project in an organization.
   *
   * Retrieve a project in an organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetProjectById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetProjectById$Response(params: OrganizationsGetProjectById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefProjectData>> {
    return organizationsGetProjectById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a project in an organization.
   *
   * Retrieve a project in an organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetProjectById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetProjectById(params: OrganizationsGetProjectById$Params, context?: HttpContext): Observable<ApiDefProjectData> {
    return this.organizationsGetProjectById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefProjectData>): ApiDefProjectData => r.body)
    );
  }

  /** Path part for operation `organizationsDeleteProjectById()` */
  static readonly OrganizationsDeleteProjectByIdPath = '/organizations/{organizationId}/projects/{projectId}';

  /**
   * Delete a project in an organization.
   *
   * Delete a project in an organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsDeleteProjectById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteProjectById$Response(params: OrganizationsDeleteProjectById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return organizationsDeleteProjectById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a project in an organization.
   *
   * Delete a project in an organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsDeleteProjectById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteProjectById(params: OrganizationsDeleteProjectById$Params, context?: HttpContext): Observable<void> {
    return this.organizationsDeleteProjectById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateProjectById()` */
  static readonly OrganizationsUpdateProjectByIdPath = '/organizations/{organizationId}/projects/{projectId}';

  /**
   * Update a project in an organization.
   *
   * Update a project in an organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateProjectById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateProjectById$Response(params: OrganizationsUpdateProjectById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefProjectData>> {
    return organizationsUpdateProjectById(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a project in an organization.
   *
   * Update a project in an organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateProjectById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateProjectById(params: OrganizationsUpdateProjectById$Params, context?: HttpContext): Observable<ApiDefProjectData> {
    return this.organizationsUpdateProjectById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefProjectData>): ApiDefProjectData => r.body)
    );
  }

  /** Path part for operation `organizationsCheckSpecAndCreateVersion()` */
  static readonly OrganizationsCheckSpecAndCreateVersionPath = '/organizations/{organizationId}/projects/{projectId}/specs';

  /**
   * Check the uploaded spec and create a new spec version.
   *
   * Check the uploaded spec and create a new spec version
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCheckSpecAndCreateVersion()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCheckSpecAndCreateVersion$Response(params: OrganizationsCheckSpecAndCreateVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The results of the spec validation
 */
'results'?: Array<ApiDefSpecCheckResult>;
'project'?: ApiDefProjectData;
}>> {
    return organizationsCheckSpecAndCreateVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Check the uploaded spec and create a new spec version.
   *
   * Check the uploaded spec and create a new spec version
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCheckSpecAndCreateVersion$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCheckSpecAndCreateVersion(params: OrganizationsCheckSpecAndCreateVersion$Params, context?: HttpContext): Observable<{

/**
 * The results of the spec validation
 */
'results'?: Array<ApiDefSpecCheckResult>;
'project'?: ApiDefProjectData;
}> {
    return this.organizationsCheckSpecAndCreateVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * The results of the spec validation
 */
'results'?: Array<ApiDefSpecCheckResult>;
'project'?: ApiDefProjectData;
}>): {

/**
 * The results of the spec validation
 */
'results'?: Array<ApiDefSpecCheckResult>;
'project'?: ApiDefProjectData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsReorderSpecs()` */
  static readonly OrganizationsReorderSpecsPath = '/organizations/{organizationId}/projects/{projectId}/reorderSpecs';

  /**
   * Reorder spec versions.
   *
   * Reorder spec versions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsReorderSpecs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsReorderSpecs$Response(params: OrganizationsReorderSpecs$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
}>> {
    return organizationsReorderSpecs(this.http, this.rootUrl, params, context);
  }

  /**
   * Reorder spec versions.
   *
   * Reorder spec versions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsReorderSpecs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsReorderSpecs(params: OrganizationsReorderSpecs$Params, context?: HttpContext): Observable<{
'project'?: ApiDefProjectData;
}> {
    return this.organizationsReorderSpecs$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'project'?: ApiDefProjectData;
}>): {
'project'?: ApiDefProjectData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsGetSpecValidationResults()` */
  static readonly OrganizationsGetSpecValidationResultsPath = '/organizations/{organizationId}/projects/{projectId}/specs/{uploadIntentId}';

  /**
   * Get the results of the spec validation.
   *
   * Retrieve the results of the spec validation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetSpecValidationResults()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetSpecValidationResults$Response(params: OrganizationsGetSpecValidationResults$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;

/**
 * The results of the spec validation
 */
'results'?: Array<ApiDefSpecCheckResult>;
}>> {
    return organizationsGetSpecValidationResults(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the results of the spec validation.
   *
   * Retrieve the results of the spec validation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetSpecValidationResults$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetSpecValidationResults(params: OrganizationsGetSpecValidationResults$Params, context?: HttpContext): Observable<{
'project'?: ApiDefProjectData;

/**
 * The results of the spec validation
 */
'results'?: Array<ApiDefSpecCheckResult>;
}> {
    return this.organizationsGetSpecValidationResults$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'project'?: ApiDefProjectData;

/**
 * The results of the spec validation
 */
'results'?: Array<ApiDefSpecCheckResult>;
}>): {
'project'?: ApiDefProjectData;

/**
 * The results of the spec validation
 */
'results'?: Array<ApiDefSpecCheckResult>;
} => r.body)
    );
  }

  /** Path part for operation `organizationsDeleteSpecVersion()` */
  static readonly OrganizationsDeleteSpecVersionPath = '/organizations/{organizationId}/projects/{projectId}/specs/{uploadIntentId}';

  /**
   * Delete a spec version.
   *
   * Delete a spec version
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsDeleteSpecVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteSpecVersion$Response(params: OrganizationsDeleteSpecVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
}>> {
    return organizationsDeleteSpecVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a spec version.
   *
   * Delete a spec version
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsDeleteSpecVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteSpecVersion(params: OrganizationsDeleteSpecVersion$Params, context?: HttpContext): Observable<{
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
}> {
    return this.organizationsDeleteSpecVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
}>): {
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateSpecVersion()` */
  static readonly OrganizationsUpdateSpecVersionPath = '/organizations/{organizationId}/projects/{projectId}/specs/{uploadIntentId}';

  /**
   * Update the name or the status of the spec version.
   *
   * Update the name or the status of the spec version
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateSpecVersion()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateSpecVersion$Response(params: OrganizationsUpdateSpecVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
}>> {
    return organizationsUpdateSpecVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the name or the status of the spec version.
   *
   * Update the name or the status of the spec version
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateSpecVersion$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateSpecVersion(params: OrganizationsUpdateSpecVersion$Params, context?: HttpContext): Observable<{
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
}> {
    return this.organizationsUpdateSpecVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
}>): {
'project'?: ApiDefProjectData;
'spec'?: ApiDefSpecData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsCheckMarkdownAndCreateVersion()` */
  static readonly OrganizationsCheckMarkdownAndCreateVersionPath = '/organizations/{organizationId}/projects/{projectId}/markdowns';

  /**
   * Check the uploaded markdown file and create a new version.
   *
   * Check the uploaded markdown file and create a new version
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCheckMarkdownAndCreateVersion()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCheckMarkdownAndCreateVersion$Response(params: OrganizationsCheckMarkdownAndCreateVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The results of the markdown validation
 */
'results'?: Array<ApiDefMarkdownCheckResult>;
'project'?: ApiDefProjectData;
}>> {
    return organizationsCheckMarkdownAndCreateVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Check the uploaded markdown file and create a new version.
   *
   * Check the uploaded markdown file and create a new version
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCheckMarkdownAndCreateVersion$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCheckMarkdownAndCreateVersion(params: OrganizationsCheckMarkdownAndCreateVersion$Params, context?: HttpContext): Observable<{

/**
 * The results of the markdown validation
 */
'results'?: Array<ApiDefMarkdownCheckResult>;
'project'?: ApiDefProjectData;
}> {
    return this.organizationsCheckMarkdownAndCreateVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * The results of the markdown validation
 */
'results'?: Array<ApiDefMarkdownCheckResult>;
'project'?: ApiDefProjectData;
}>): {

/**
 * The results of the markdown validation
 */
'results'?: Array<ApiDefMarkdownCheckResult>;
'project'?: ApiDefProjectData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsReorderMarkdowns()` */
  static readonly OrganizationsReorderMarkdownsPath = '/organizations/{organizationId}/projects/{projectId}/reorderMarkdowns';

  /**
   * Reorder markdown versions.
   *
   * Reorder markdown versions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsReorderMarkdowns()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsReorderMarkdowns$Response(params: OrganizationsReorderMarkdowns$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
}>> {
    return organizationsReorderMarkdowns(this.http, this.rootUrl, params, context);
  }

  /**
   * Reorder markdown versions.
   *
   * Reorder markdown versions
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsReorderMarkdowns$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsReorderMarkdowns(params: OrganizationsReorderMarkdowns$Params, context?: HttpContext): Observable<{
'project'?: ApiDefProjectData;
}> {
    return this.organizationsReorderMarkdowns$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'project'?: ApiDefProjectData;
}>): {
'project'?: ApiDefProjectData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsGetMarkdownValidationResults()` */
  static readonly OrganizationsGetMarkdownValidationResultsPath = '/organizations/{organizationId}/projects/{projectId}/markdowns/{uploadIntentId}';

  /**
   * Get the results of the markdown validation.
   *
   * Retrieve the results of the markdown validation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetMarkdownValidationResults()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetMarkdownValidationResults$Response(params: OrganizationsGetMarkdownValidationResults$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;

/**
 * The results of the markdown validation
 */
'results'?: Array<ApiDefMarkdownCheckResult>;
}>> {
    return organizationsGetMarkdownValidationResults(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the results of the markdown validation.
   *
   * Retrieve the results of the markdown validation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetMarkdownValidationResults$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetMarkdownValidationResults(params: OrganizationsGetMarkdownValidationResults$Params, context?: HttpContext): Observable<{
'project'?: ApiDefProjectData;

/**
 * The results of the markdown validation
 */
'results'?: Array<ApiDefMarkdownCheckResult>;
}> {
    return this.organizationsGetMarkdownValidationResults$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'project'?: ApiDefProjectData;

/**
 * The results of the markdown validation
 */
'results'?: Array<ApiDefMarkdownCheckResult>;
}>): {
'project'?: ApiDefProjectData;

/**
 * The results of the markdown validation
 */
'results'?: Array<ApiDefMarkdownCheckResult>;
} => r.body)
    );
  }

  /** Path part for operation `organizationsDeleteMarkdownVersion()` */
  static readonly OrganizationsDeleteMarkdownVersionPath = '/organizations/{organizationId}/projects/{projectId}/markdowns/{uploadIntentId}';

  /**
   * Delete a markdown version.
   *
   * Delete a markdown version
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsDeleteMarkdownVersion()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteMarkdownVersion$Response(params: OrganizationsDeleteMarkdownVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
}>> {
    return organizationsDeleteMarkdownVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a markdown version.
   *
   * Delete a markdown version
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsDeleteMarkdownVersion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteMarkdownVersion(params: OrganizationsDeleteMarkdownVersion$Params, context?: HttpContext): Observable<{
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
}> {
    return this.organizationsDeleteMarkdownVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
}>): {
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateMarkdownVersion()` */
  static readonly OrganizationsUpdateMarkdownVersionPath = '/organizations/{organizationId}/projects/{projectId}/markdowns/{uploadIntentId}';

  /**
   * Update the name or the status of the markdown version.
   *
   * Update the name or the status of the markdown version
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateMarkdownVersion()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateMarkdownVersion$Response(params: OrganizationsUpdateMarkdownVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
}>> {
    return organizationsUpdateMarkdownVersion(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the name or the status of the markdown version.
   *
   * Update the name or the status of the markdown version
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateMarkdownVersion$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateMarkdownVersion(params: OrganizationsUpdateMarkdownVersion$Params, context?: HttpContext): Observable<{
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
}> {
    return this.organizationsUpdateMarkdownVersion$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
}>): {
'project'?: ApiDefProjectData;
'markdown'?: ApiDefMarkdownData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsGetUsers()` */
  static readonly OrganizationsGetUsersPath = '/organizations/{organizationId}/users';

  /**
   * Get all users in an organization.
   *
   * Retrieve all users associated with the organization along with their roles.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetUsers$Response(params: OrganizationsGetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<{
'user'?: ApiDefUserData;

/**
 * The user's role in the organization
 */
'role'?: 'owner' | 'admin' | 'viewer';
}>>> {
    return organizationsGetUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all users in an organization.
   *
   * Retrieve all users associated with the organization along with their roles.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetUsers(params: OrganizationsGetUsers$Params, context?: HttpContext): Observable<Array<{
'user'?: ApiDefUserData;

/**
 * The user's role in the organization
 */
'role'?: 'owner' | 'admin' | 'viewer';
}>> {
    return this.organizationsGetUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
'user'?: ApiDefUserData;

/**
 * The user's role in the organization
 */
'role'?: 'owner' | 'admin' | 'viewer';
}>>): Array<{
'user'?: ApiDefUserData;

/**
 * The user's role in the organization
 */
'role'?: 'owner' | 'admin' | 'viewer';
}> => r.body)
    );
  }

  /** Path part for operation `organizationsAddOrInviteUser()` */
  static readonly OrganizationsAddOrInviteUserPath = '/organizations/{organizationId}/users';

  /**
   * Add or invite a user to the organization.
   *
   * Adds a registered user to the organization or sends an invitation (if the user is not registered) along with the assigned role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsAddOrInviteUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsAddOrInviteUser$Response(params: OrganizationsAddOrInviteUser$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;

/**
 * Indicates if an invitation email was sent
 */
'invitationSent'?: boolean;
'invitation'?: ApiDefInvitationData;
}>> {
    return organizationsAddOrInviteUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Add or invite a user to the organization.
   *
   * Adds a registered user to the organization or sends an invitation (if the user is not registered) along with the assigned role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsAddOrInviteUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsAddOrInviteUser(params: OrganizationsAddOrInviteUser$Params, context?: HttpContext): Observable<{
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;

/**
 * Indicates if an invitation email was sent
 */
'invitationSent'?: boolean;
'invitation'?: ApiDefInvitationData;
}> {
    return this.organizationsAddOrInviteUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;

/**
 * Indicates if an invitation email was sent
 */
'invitationSent'?: boolean;
'invitation'?: ApiDefInvitationData;
}>): {
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;

/**
 * Indicates if an invitation email was sent
 */
'invitationSent'?: boolean;
'invitation'?: ApiDefInvitationData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsRemoveUser()` */
  static readonly OrganizationsRemoveUserPath = '/organizations/{organizationId}/users/{userId}';

  /**
   * Remove a user from the organization.
   *
   * Remove a user from the specified organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsRemoveUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsRemoveUser$Response(params: OrganizationsRemoveUser$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
}>> {
    return organizationsRemoveUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove a user from the organization.
   *
   * Remove a user from the specified organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsRemoveUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsRemoveUser(params: OrganizationsRemoveUser$Params, context?: HttpContext): Observable<{
'organization'?: ApiDefOrganizationData;
}> {
    return this.organizationsRemoveUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
}>): {
'organization'?: ApiDefOrganizationData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateUserRole()` */
  static readonly OrganizationsUpdateUserRolePath = '/organizations/{organizationId}/users/{userId}';

  /**
   * Update a user's role in the organization.
   *
   * Update the role of an existing organization user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateUserRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateUserRole$Response(params: OrganizationsUpdateUserRole$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;
'role'?: 'owner' | 'admin' | 'viewer';
}>> {
    return organizationsUpdateUserRole(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a user's role in the organization.
   *
   * Update the role of an existing organization user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateUserRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateUserRole(params: OrganizationsUpdateUserRole$Params, context?: HttpContext): Observable<{
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;
'role'?: 'owner' | 'admin' | 'viewer';
}> {
    return this.organizationsUpdateUserRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;
'role'?: 'owner' | 'admin' | 'viewer';
}>): {
'organization'?: ApiDefOrganizationData;
'user'?: ApiDefUserData;
'role'?: 'owner' | 'admin' | 'viewer';
} => r.body)
    );
  }

  /** Path part for operation `organizationsGetPendingInvitations()` */
  static readonly OrganizationsGetPendingInvitationsPath = '/organizations/{organizationId}/users/invitations';

  /**
   * List pending invitations for the organization.
   *
   * Retrieve all pending user invitations (for unregistered users) in the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetPendingInvitations()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetPendingInvitations$Response(params: OrganizationsGetPendingInvitations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiDefInvitationData>>> {
    return organizationsGetPendingInvitations(this.http, this.rootUrl, params, context);
  }

  /**
   * List pending invitations for the organization.
   *
   * Retrieve all pending user invitations (for unregistered users) in the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetPendingInvitations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetPendingInvitations(params: OrganizationsGetPendingInvitations$Params, context?: HttpContext): Observable<Array<ApiDefInvitationData>> {
    return this.organizationsGetPendingInvitations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ApiDefInvitationData>>): Array<ApiDefInvitationData> => r.body)
    );
  }

  /** Path part for operation `organizationsGetInvitationById()` */
  static readonly OrganizationsGetInvitationByIdPath = '/organizations/{organizationId}/users/invitations/{invitationId}';

  /**
   * Get details of a specific invitation.
   *
   * Retrieve details of a specific pending invitation to join the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetInvitationById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetInvitationById$Response(params: OrganizationsGetInvitationById$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The name of the organization
 */
'organizationName'?: string;
'invitation'?: ApiDefInvitationData;
}>> {
    return organizationsGetInvitationById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get details of a specific invitation.
   *
   * Retrieve details of a specific pending invitation to join the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetInvitationById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetInvitationById(params: OrganizationsGetInvitationById$Params, context?: HttpContext): Observable<{

/**
 * The name of the organization
 */
'organizationName'?: string;
'invitation'?: ApiDefInvitationData;
}> {
    return this.organizationsGetInvitationById$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * The name of the organization
 */
'organizationName'?: string;
'invitation'?: ApiDefInvitationData;
}>): {

/**
 * The name of the organization
 */
'organizationName'?: string;
'invitation'?: ApiDefInvitationData;
} => r.body)
    );
  }

  /** Path part for operation `organizationsCancelInvitation()` */
  static readonly OrganizationsCancelInvitationPath = '/organizations/{organizationId}/users/invitations/{invitationId}';

  /**
   * Delete an organization user invitation. It sets the status to canceled.
   *
   * Delete a pending invitation to join the organization. It sets the status to canceled.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCancelInvitation()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsCancelInvitation$Response(params: OrganizationsCancelInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The status of the canceled invitation
 */
'status'?: string;
}>> {
    return organizationsCancelInvitation(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an organization user invitation. It sets the status to canceled.
   *
   * Delete a pending invitation to join the organization. It sets the status to canceled.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCancelInvitation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsCancelInvitation(params: OrganizationsCancelInvitation$Params, context?: HttpContext): Observable<{

/**
 * The status of the canceled invitation
 */
'status'?: string;
}> {
    return this.organizationsCancelInvitation$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * The status of the canceled invitation
 */
'status'?: string;
}>): {

/**
 * The status of the canceled invitation
 */
'status'?: string;
} => r.body)
    );
  }

  /** Path part for operation `organizationsRespondInvitation()` */
  static readonly OrganizationsRespondInvitationPath = '/organizations/{organizationId}/users/invitations/{invitationId}';

  /**
   * Respond to an organization invitation.
   *
   * Accept or decline a pending invitation to join the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsRespondInvitation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsRespondInvitation$Response(params: OrganizationsRespondInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The updated status of the invitation
 */
'status'?: string;
}>> {
    return organizationsRespondInvitation(this.http, this.rootUrl, params, context);
  }

  /**
   * Respond to an organization invitation.
   *
   * Accept or decline a pending invitation to join the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsRespondInvitation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsRespondInvitation(params: OrganizationsRespondInvitation$Params, context?: HttpContext): Observable<{

/**
 * The updated status of the invitation
 */
'status'?: string;
}> {
    return this.organizationsRespondInvitation$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * The updated status of the invitation
 */
'status'?: string;
}>): {

/**
 * The updated status of the invitation
 */
'status'?: string;
} => r.body)
    );
  }

  /** Path part for operation `organizationsResendInvitation()` */
  static readonly OrganizationsResendInvitationPath = '/organizations/{organizationId}/users/invitations/{invitationId}/resend';

  /**
   * Resend an organization invitation.
   *
   * Resend a pending invitation to join the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsResendInvitation()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsResendInvitation$Response(params: OrganizationsResendInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The status of the resent invitation
 */
'status'?: string;
}>> {
    return organizationsResendInvitation(this.http, this.rootUrl, params, context);
  }

  /**
   * Resend an organization invitation.
   *
   * Resend a pending invitation to join the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsResendInvitation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsResendInvitation(params: OrganizationsResendInvitation$Params, context?: HttpContext): Observable<{

/**
 * The status of the resent invitation
 */
'status'?: string;
}> {
    return this.organizationsResendInvitation$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * The status of the resent invitation
 */
'status'?: string;
}>): {

/**
 * The status of the resent invitation
 */
'status'?: string;
} => r.body)
    );
  }

  /** Path part for operation `organizationsListApiKeys()` */
  static readonly OrganizationsListApiKeysPath = '/organizations/{organizationId}/api-keys';

  /**
   * List API keys for the organization.
   *
   * List all API keys for the organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsListApiKeys()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsListApiKeys$Response(params: OrganizationsListApiKeys$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ApiDefApiKeyData>>> {
    return organizationsListApiKeys(this.http, this.rootUrl, params, context);
  }

  /**
   * List API keys for the organization.
   *
   * List all API keys for the organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsListApiKeys$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsListApiKeys(params: OrganizationsListApiKeys$Params, context?: HttpContext): Observable<Array<ApiDefApiKeyData>> {
    return this.organizationsListApiKeys$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ApiDefApiKeyData>>): Array<ApiDefApiKeyData> => r.body)
    );
  }

  /** Path part for operation `organizationsCreateApiKey()` */
  static readonly OrganizationsCreateApiKeyPath = '/organizations/{organizationId}/api-keys';

  /**
   * Create a new API key.
   *
   * Create a new API key for the organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCreateApiKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateApiKey$Response(params: OrganizationsCreateApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'apiKey'?: ApiDefApiKeyData;

/**
 * The API key value (only returned on creation)
 */
'plainKey'?: string;
}>> {
    return organizationsCreateApiKey(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new API key.
   *
   * Create a new API key for the organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCreateApiKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateApiKey(params: OrganizationsCreateApiKey$Params, context?: HttpContext): Observable<{
'apiKey'?: ApiDefApiKeyData;

/**
 * The API key value (only returned on creation)
 */
'plainKey'?: string;
}> {
    return this.organizationsCreateApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'apiKey'?: ApiDefApiKeyData;

/**
 * The API key value (only returned on creation)
 */
'plainKey'?: string;
}>): {
'apiKey'?: ApiDefApiKeyData;

/**
 * The API key value (only returned on creation)
 */
'plainKey'?: string;
} => r.body)
    );
  }

  /** Path part for operation `organizationsGetApiKey()` */
  static readonly OrganizationsGetApiKeyPath = '/organizations/{organizationId}/api-keys/{apiKeyId}';

  /**
   * Get an API key by ID.
   *
   * Get details of a specific API key
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetApiKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetApiKey$Response(params: OrganizationsGetApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefApiKeyData>> {
    return organizationsGetApiKey(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an API key by ID.
   *
   * Get details of a specific API key
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetApiKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetApiKey(params: OrganizationsGetApiKey$Params, context?: HttpContext): Observable<ApiDefApiKeyData> {
    return this.organizationsGetApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefApiKeyData>): ApiDefApiKeyData => r.body)
    );
  }

  /** Path part for operation `organizationsDeleteApiKey()` */
  static readonly OrganizationsDeleteApiKeyPath = '/organizations/{organizationId}/api-keys/{apiKeyId}';

  /**
   * Delete an API key.
   *
   * Delete an API key by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsDeleteApiKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteApiKey$Response(params: OrganizationsDeleteApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefApiKeyData>> {
    return organizationsDeleteApiKey(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an API key.
   *
   * Delete an API key by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsDeleteApiKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteApiKey(params: OrganizationsDeleteApiKey$Params, context?: HttpContext): Observable<ApiDefApiKeyData> {
    return this.organizationsDeleteApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefApiKeyData>): ApiDefApiKeyData => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateApiKey()` */
  static readonly OrganizationsUpdateApiKeyPath = '/organizations/{organizationId}/api-keys/{apiKeyId}';

  /**
   * Update an API key.
   *
   * Update an API key's name, projects, or expiration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateApiKey()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateApiKey$Response(params: OrganizationsUpdateApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefApiKeyData>> {
    return organizationsUpdateApiKey(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an API key.
   *
   * Update an API key's name, projects, or expiration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateApiKey$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateApiKey(params: OrganizationsUpdateApiKey$Params, context?: HttpContext): Observable<ApiDefApiKeyData> {
    return this.organizationsUpdateApiKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefApiKeyData>): ApiDefApiKeyData => r.body)
    );
  }

  /** Path part for operation `organizationsCreateOrUpdateSubscription()` */
  static readonly OrganizationsCreateOrUpdateSubscriptionPath = '/organizations/{organizationId}/subscription';

  /**
   * Create or update the organization's subscription.
   *
   * Create or update the subscription for the organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCreateOrUpdateSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateOrUpdateSubscription$Response(params: OrganizationsCreateOrUpdateSubscription$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSubscriptionChangeResponse>> {
    return organizationsCreateOrUpdateSubscription(this.http, this.rootUrl, params, context);
  }

  /**
   * Create or update the organization's subscription.
   *
   * Create or update the subscription for the organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCreateOrUpdateSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateOrUpdateSubscription(params: OrganizationsCreateOrUpdateSubscription$Params, context?: HttpContext): Observable<ApiDefSubscriptionChangeResponse> {
    return this.organizationsCreateOrUpdateSubscription$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefSubscriptionChangeResponse>): ApiDefSubscriptionChangeResponse => r.body)
    );
  }

  /** Path part for operation `organizationsCancelScheduledChange()` */
  static readonly OrganizationsCancelScheduledChangePath = '/organizations/{organizationId}/subscription/scheduled-change';

  /**
   * Cancel a scheduled subscription change.
   *
   * Cancel a pending scheduled downgrade, keeping the current subscription plan active
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCancelScheduledChange()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCancelScheduledChange$Response(params: OrganizationsCancelScheduledChange$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSubscriptionChangeResponse>> {
    return organizationsCancelScheduledChange(this.http, this.rootUrl, params, context);
  }

  /**
   * Cancel a scheduled subscription change.
   *
   * Cancel a pending scheduled downgrade, keeping the current subscription plan active
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCancelScheduledChange$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCancelScheduledChange(params: OrganizationsCancelScheduledChange$Params, context?: HttpContext): Observable<ApiDefSubscriptionChangeResponse> {
    return this.organizationsCancelScheduledChange$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefSubscriptionChangeResponse>): ApiDefSubscriptionChangeResponse => r.body)
    );
  }

  /** Path part for operation `organizationsCreateBillingPortalSession()` */
  static readonly OrganizationsCreateBillingPortalSessionPath = '/organizations/{organizationId}/subscription/billing-portal-session';

  /**
   * Create a Stripe Billing Portal session.
   *
   * Create a Stripe Billing Portal session URL for organization owners to self-manage billing details.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCreateBillingPortalSession()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsCreateBillingPortalSession$Response(params: OrganizationsCreateBillingPortalSession$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Stripe Billing Portal URL.
 */
'url': string;
}>> {
    return organizationsCreateBillingPortalSession(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a Stripe Billing Portal session.
   *
   * Create a Stripe Billing Portal session URL for organization owners to self-manage billing details.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCreateBillingPortalSession$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsCreateBillingPortalSession(params: OrganizationsCreateBillingPortalSession$Params, context?: HttpContext): Observable<{

/**
 * Stripe Billing Portal URL.
 */
'url': string;
}> {
    return this.organizationsCreateBillingPortalSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<{

/**
 * Stripe Billing Portal URL.
 */
'url': string;
}>): {

/**
 * Stripe Billing Portal URL.
 */
'url': string;
} => r.body)
    );
  }

  /** Path part for operation `organizationsGetPaymentRecovery()` */
  static readonly OrganizationsGetPaymentRecoveryPath = '/organizations/{organizationId}/subscription/payment-recovery';

  /**
   * Get the current pending-payment recovery action.
   *
   * Retrieve a current Stripe-hosted payment recovery action for an organization owner. Hosted payment URLs are not included in general organization state and are never returned to administrators or viewers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetPaymentRecovery()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetPaymentRecovery$Response(params: OrganizationsGetPaymentRecovery$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefPaymentRecoveryResponse>> {
    return organizationsGetPaymentRecovery(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the current pending-payment recovery action.
   *
   * Retrieve a current Stripe-hosted payment recovery action for an organization owner. Hosted payment URLs are not included in general organization state and are never returned to administrators or viewers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetPaymentRecovery$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetPaymentRecovery(params: OrganizationsGetPaymentRecovery$Params, context?: HttpContext): Observable<ApiDefPaymentRecoveryResponse> {
    return this.organizationsGetPaymentRecovery$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefPaymentRecoveryResponse>): ApiDefPaymentRecoveryResponse => r.body)
    );
  }

  /** Path part for operation `organizationsGetBillingHistory()` */
  static readonly OrganizationsGetBillingHistoryPath = '/organizations/{organizationId}/billing/history';

  /**
   * Get billing history for the organization.
   *
   * List billing history entries for the organization, ordered by occurrence time and entry ID, newest first. Cursor pagination is preferred; page remains available for backward compatibility.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetBillingHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetBillingHistory$Response(params: OrganizationsGetBillingHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefBillingHistoryListResponse>> {
    return organizationsGetBillingHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get billing history for the organization.
   *
   * List billing history entries for the organization, ordered by occurrence time and entry ID, newest first. Cursor pagination is preferred; page remains available for backward compatibility.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetBillingHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetBillingHistory(params: OrganizationsGetBillingHistory$Params, context?: HttpContext): Observable<ApiDefBillingHistoryListResponse> {
    return this.organizationsGetBillingHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefBillingHistoryListResponse>): ApiDefBillingHistoryListResponse => r.body)
    );
  }

  /** Path part for operation `organizationsGetSupportReports()` */
  static readonly OrganizationsGetSupportReportsPath = '/organizations/{organizationId}/support';

  /**
   * Get all support reports for the organization.
   *
   * List all support reports, optionally filtered and paginated
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetSupportReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetSupportReports$Response(params: OrganizationsGetSupportReports$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'reports'?: Array<ApiDefSupportReport>;
'total'?: number;
}>> {
    return organizationsGetSupportReports(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all support reports for the organization.
   *
   * List all support reports, optionally filtered and paginated
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetSupportReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetSupportReports(params: OrganizationsGetSupportReports$Params, context?: HttpContext): Observable<{
'reports'?: Array<ApiDefSupportReport>;
'total'?: number;
}> {
    return this.organizationsGetSupportReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'reports'?: Array<ApiDefSupportReport>;
'total'?: number;
}>): {
'reports'?: Array<ApiDefSupportReport>;
'total'?: number;
} => r.body)
    );
  }

  /** Path part for operation `organizationsCreateSupportReport()` */
  static readonly OrganizationsCreateSupportReportPath = '/organizations/{organizationId}/support';

  /**
   * Create a support report.
   *
   * Submit a new support report for the organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsCreateSupportReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateSupportReport$Response(params: OrganizationsCreateSupportReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSupportReport>> {
    return organizationsCreateSupportReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a support report.
   *
   * Submit a new support report for the organization
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsCreateSupportReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsCreateSupportReport(params: OrganizationsCreateSupportReport$Params, context?: HttpContext): Observable<ApiDefSupportReport> {
    return this.organizationsCreateSupportReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefSupportReport>): ApiDefSupportReport => r.body)
    );
  }

  /** Path part for operation `organizationsGetSupportReportById()` */
  static readonly OrganizationsGetSupportReportByIdPath = '/organizations/{organizationId}/support/{reportId}';

  /**
   * Get a support report by ID.
   *
   * Get details of a specific support report
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsGetSupportReportById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetSupportReportById$Response(params: OrganizationsGetSupportReportById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSupportReport>> {
    return organizationsGetSupportReportById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a support report by ID.
   *
   * Get details of a specific support report
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsGetSupportReportById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsGetSupportReportById(params: OrganizationsGetSupportReportById$Params, context?: HttpContext): Observable<ApiDefSupportReport> {
    return this.organizationsGetSupportReportById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefSupportReport>): ApiDefSupportReport => r.body)
    );
  }

  /** Path part for operation `organizationsDeleteSupportReport()` */
  static readonly OrganizationsDeleteSupportReportPath = '/organizations/{organizationId}/support/{reportId}';

  /**
   * Delete a support report.
   *
   * Delete a support report by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsDeleteSupportReport()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteSupportReport$Response(params: OrganizationsDeleteSupportReport$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return organizationsDeleteSupportReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a support report.
   *
   * Delete a support report by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsDeleteSupportReport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsDeleteSupportReport(params: OrganizationsDeleteSupportReport$Params, context?: HttpContext): Observable<void> {
    return this.organizationsDeleteSupportReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `organizationsUpdateSupportReport()` */
  static readonly OrganizationsUpdateSupportReportPath = '/organizations/{organizationId}/support/{reportId}';

  /**
   * Update a support report.
   *
   * Update fields such as status, tags, priority, or add notes
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsUpdateSupportReport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateSupportReport$Response(params: OrganizationsUpdateSupportReport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSupportReport>> {
    return organizationsUpdateSupportReport(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a support report.
   *
   * Update fields such as status, tags, priority, or add notes
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsUpdateSupportReport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationsUpdateSupportReport(params: OrganizationsUpdateSupportReport$Params, context?: HttpContext): Observable<ApiDefSupportReport> {
    return this.organizationsUpdateSupportReport$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiDefSupportReport>): ApiDefSupportReport => r.body)
    );
  }

}
